/**
 * This component is a group of select Field
 *
 * @module views/components/DependentField
 * @memberof -Common
 */

import React from 'react';

import PropTypes from 'prop-types';

import DependentSelectField from '@ulta/components/DependentSelectField/DependentSelectField';

/**
 * Represents a DependentField component
 *
 * @method
 * @param { DependentFieldProps} props - React properties passed from composition
 * @returns DependentField
 */

export const DependentField = function( props ){

  const { field, dependentFields, level = defaultProps.level, name } = props;

  switch ( field?.moduleName ){
    case DEPENDENT_FIELD_TYPES.SelectField:
      return (
        <DependentSelectField field={ field }
          dependentFields={ dependentFields }
          name={ name }
          level={ level }
          enabled={ field.enabled }
        />
      );
    default:
      return null;
  }
};

export const DEPENDENT_FIELD_TYPES = {
  SelectField: 'SelectField'
};

/**
 * Property type definitions
 * @typedef DependentFieldProps
 * @type {object}
 * @property {object} field - sets field
 * @property {array} dependentFields - sets dependentFields
 * @property {number} level - sets level
 * @property {string} name - sets name
 */
export const propTypes =  {
  /** sets field */
  field: PropTypes.object,
  /** Sets dependentFields */
  dependentFields: PropTypes.array,
  /** Sets the level */
  level: PropTypes.number,
  /** Sets the name */
  name: PropTypes.string
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} example='hello world' - The default refactor or delete
 */
export const defaultProps =  {
  level: 1
};

DependentField.propTypes = propTypes;
DependentField.defaultProps = defaultProps;

export default DependentField;
